import { defineMessages } from 'react-intl';

import { MediaSchema } from '@fhnw/schemas/media';

const messages = defineMessages({
  ImageSlider: {
    id: 'Image Slider',
    defaultMessage: 'Image Slider',
  },
  items: {
    id: 'Items',
    defaultMessage: 'Items',
  },
  slider: {
    id: 'label_display_as_slider',
    defaultMessage: 'Display as slider',
  },
});

export const ImageSliderSchema = (props) => ({
  title: props.intl.formatMessage(messages.ImageSlider),
  block: 'imageslider',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['slider', 'slides'],
    },
  ],
  properties: {
    slider: {
      title: props.intl.formatMessage(messages.slider),
      widgetOptions: {
        frontendOptions: {
          widget: 'checkbox',
        },
      },
    },
    slides: {
      title: props.intl.formatMessage(messages.items),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: MediaSchema(props),
          },
        },
      },
      default: [],
    },
  },
  required: [],
});
